import React, { useContext } from 'react';
import { DestinationContext } from '../../../contexts/DestinationContext';
import styles from './BestTimeCalendar.module.scss';

const badgeClass = (rating = '') => {
  const r = rating.toLowerCase();
  if (r.includes('excellent') || r.includes('best')) return styles.best;
  if (r.includes('good')) return styles.good;
  if (r.includes('shoulder')) return styles.shoulder;
  return styles.low;
};

// A quick visual read of the season per month — sun for the dry/best
// months, fading through cloud to rain for the wetter, lower-rated ones.
// Shoulder months are usually the "short rains" — give those a touch of
// rain too instead of a plain cloud, so the icon actually reads as rainy.
const monthIcon = (rating = '', season = '') => {
  const r = rating.toLowerCase();
  const s = season.toLowerCase();
  if (r.includes('excellent') || r.includes('best')) return '☀';
  if (r.includes('good')) return '🌤';
  if (r.includes('shoulder')) return s.includes('rain') ? '🌦' : '⛅';
  return '🌧';
};

const BestTimeCalendar = () => {
  const destination = useContext(DestinationContext);
  const bestTimeToVisit = destination?.bestTimeToVisit;
  const months = bestTimeToVisit?.months;

  if (!Array.isArray(months) || months.length === 0) return null;

  return (
    <section className={styles.section}>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <div className={styles.eyebrow}>{bestTimeToVisit.headlineStatNumber || 'When to Go'}</div>
          {bestTimeToVisit.headlineStatLabel ? (
            <h2
              className={styles.heading}
              dangerouslySetInnerHTML={{ __html: bestTimeToVisit.headlineStatLabel }}
            />
          ) : (
            <h2 className={styles.heading}>Best Time to Visit</h2>
          )}

          {Array.isArray(bestTimeToVisit.legend) && bestTimeToVisit.legend.length > 0 && (
            <div className={styles.legend}>
              {bestTimeToVisit.legend.map((item) => (
                <span key={item} className={styles.legendItem}>
                  <i className={badgeClass(item)} /> {item}
                </span>
              ))}
            </div>
          )}
        </div>

        <div className={styles.cal}>
          {months.map((m, i) => (
            <div className={`${styles.mo} ${badgeClass(m.rating)}`} key={m.name || i}>
              <span className={styles.icon}>{monthIcon(m.rating, m.season)}</span>
              <div className={styles.m}>{m.name}</div>
              {m.season && <div className={styles.season}>{m.season}</div>}
              <span className={`${styles.badge} ${badgeClass(m.rating)}`}>{m.rating}</span>
            </div>
          ))}
        </div>

        {bestTimeToVisit.calloutText && (
          <div className={styles.callout}>{bestTimeToVisit.calloutText}</div>
        )}
      </div>
    </section>
  );
};

export default BestTimeCalendar;
